import { useEffect, useState } from 'react'
import { useGlobal } from '../core/GlobalContext'
import { VALIDATION_STATUS } from '../core/actions'
import { currencyParser } from '../utils/misc'

const usePurchaseValidation = (purchaseAmount, purchase) => {
  const {
    financierState: {
      financier: { walletBalance, fixedIRR, enableBuyButton, disableBuyButtonMessage },
    },
  } = useGlobal()

  const [response, setResponse] = useState({
    status: VALIDATION_STATUS.IDLE,
    message: 'Yet to begin',
    action: () => {},
    actionText: '',
  })

  const handleDeposit = () => {
    console.log('Handling Additional money deposit')
  }

  useEffect(() => {
    if (!enableBuyButton) {
      setResponse({
        status: VALIDATION_STATUS.FAILURE,
        message: disableBuyButtonMessage || 'Action not permitted, contact support',
        action: () => {},
        actionText: '',
      })
    } else if (purchaseAmount === 0 || purchaseAmount === '' || !purchaseAmount) {
      setResponse({
        status: VALIDATION_STATUS.IDLE,
        message: `Enter a valid purchase amount.`,
        action: () => {},
        actionText: '',
      })
    } else if (purchaseAmount < purchase?.minClearedAmount) {
      setResponse({
        status: VALIDATION_STATUS.FAILURE,
        message: 'Minimum purchase amount criteria not met.',
        action: () => {},
        actionText: '',
      })
    } else if (purchaseAmount > walletBalance) {
      setResponse({
        status: VALIDATION_STATUS.WARNING,
        message: `Add ${currencyParser(purchaseAmount - walletBalance)} to your wallet to buy this deal.`,
        action: handleDeposit,
        actionText: '',
      })
    } else if (purchaseAmount > purchase?.availableAmount) {
      setResponse({
        status: VALIDATION_STATUS.WARNING,
        message: `Too much! Consider to invest ${currencyParser(
          purchaseAmount - purchase?.availableAmount
        )} in other deals.`,
        action: () => {},
        actionText: '',
      })
    } else if (purchaseAmount > purchase?.totalAmount) {
      setResponse({
        status: VALIDATION_STATUS.WARNING,
        message: `Too much! Consider to invest ${currencyParser(
          purchaseAmount - purchase?.totalAmount
        )} in other deals.`,
        action: () => {},
        actionText: '',
      })
    } else if (fixedIRR && purchase?.isAR) {
      setResponse({
        status: VALIDATION_STATUS.FAILURE,
        message: `Investors with fixed IRRs cannot buy AR deal.`,
        action: () => {},
        actionText: '',
      })
    } else {
      setResponse({
        status: VALIDATION_STATUS.SUCCESS,
        message: 'Ready to purchase.',
        action: () => {},
        actionText: '',
      })
    }
  }, [purchaseAmount, purchase, walletBalance, fixedIRR, enableBuyButton, disableBuyButtonMessage])

  return response
}

export default usePurchaseValidation
